import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router";
import { Button } from "react-bootstrap";

import ZubehoerCompressorContainer from "./ZubehoerCompressorContainer";
import ZubehoerMasterContainer from "./ZubehoerMasterContainer";

import "./Zubehoer.css";

const Zubehoer = props => (
	<div className="Zubehoer">
		<div>
			<div>
				<Button className="almig-previous-button almig-image-button"
					disabled={props.previous_index === null}
					onClick={() => props.gotoCompressor(
						props.location_path, props.previous_index)} />
				<Button className="almig-next-button  almig-image-button"
					disabled={props.next_index === null}
					onClick={() => props.gotoCompressor(
						props.location_path, props.next_index)} />
			</div>
		</div>
		<Switch>
			<Route path="/overview/accessories/master" component={ZubehoerMasterContainer} />
			<Route path="/overview/accessories/:compressor" component={ZubehoerCompressorContainer} />
			<Redirect exact from="/overview/accessories" to={props.default_path} />
		</Switch>
	</div>
);

Zubehoer.propTypes = {
	location_path: PropTypes.string.isRequired,
	default_path: PropTypes.string.isRequired,
	previous_index: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	next_index: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	gotoCompressor: PropTypes.func.isRequired
};

export default Zubehoer;
